module.exports={
        appName: '米悦小说',
        index:'首页',
        man: '男频',
        woman: "精选",
        womanlabel:"女频",
        end:"完结",
        rank:"人气榜",
        login:"登录",
        reg:'注册',
        bookMsg:'我的书架',
        addShelf:'加入书架',
        onShelf:'已在书架',
        searchMsg:'搜索',
        fb:'米悦小说FACEBOOK粉丝页',
        focus:'关注',
        kefu:'客服电邮：',
        noresult:"暂无小说上架~",
        shelf:"书架",
        searchTip:"请输入书名或关键词",
        updateAt:"更新于",
        more:"更多>",
        account:"账号",
        memAccount:"会员账号",
        balance:"余额",
        balancetip:"本章是VIP章节，订阅后即可阅读",
        coin:"金币",
        payType:"储值方式",
        payAmount:"储值金额",
        resultCoin:"获得金币",
        giftCoin:"加赠",
        dollar:"美元",
        mlpay:"马来西亚储值",
        price:"章节价格",
        charge:"在线储值",
        charge2:"充值",
        paypalpay:"PayPal支付",
        pftpay:"派付通支付",
        discount:"折",
        nomoredata:"没有更多数据了。。。。",
        read:"立即阅读",
        chapters:"查看目录",
        serialize:"连载至",
        chapter:"章",
        cmtList:"书评区",
        cmt:"评论",
        clickMore:"点击查看更多",
        guessLike:"猜你喜欢",
        loading:"拼命加载中。。。",
        free:"免费",
        total:"共",
        confirm:"确定",
        chooseSex:"请选择性别",
        chooseLang:"请选择语言",
        "第":"第",
        page:"页",
        nextPage:"下一页",
        changePwd:"修改密码",
        oldPwd:"原密码",
        newPwd:"新密码",
        confirmPwd:"确认密码",
        inputPwd:"请输入密码",
        inputNewPwd:"请输入新密码",
        inputOldPwd:"请输入旧密码",
        inputPwd2:"请再次输入密码",
        pwdNotMatch:"两次输入密码不匹配",
        changePwdSuccess:"密码修改成功",
        inputCmt:"请输入您的评论",
        feedback:"意见反馈",
        inputFeedback:"请输入您的宝贵意见",
        feedbackSuccess:"您的意见已提交，我们将尽快回复您",
        lastRead:"上次阅读",
        latestRead:"最近阅读",
        click:"点击",
        fav:"收藏",
        then:"”然后选择“",
        readNextTime:"方便下次阅读喔",
        loginPage:"米悦小说账号登录",
        regPage:"米悦小说账号注册",
        memPwd:"会员密码",
        memLogin:"会员登录",
        memReg:"注册账号",
        inputAccount:"电子邮箱/手机号码/昵称",
        myCoin:"我的书币",
        langSetting:"语言设置",
        download:"下载米悦小说APP",
        my:"个人中心",
        delShelf:"删除书架",
        home:"返回首页",
        cancle:"取消",
        clickDownload:"一键安装米悦小说官方小说APP",
        menu:"菜单",
        preChapter:"上一章",
        nextChapter:"下一章",
        addShelfTip:"是否加入书架？方便下次阅读",
        gender:"会员性别",
        memPwd:"会员密码",
        male:"男",
        female:"女",
        regNow:"立即注册",
        searchHistory:"历史搜索",
        submit:"提交",
        detail:"书籍详情",
        logout:"退出登录",
        morePay:"更多储值",
        hotsearch:"热门搜索",
}


//////////////////
// WEBPACK FOOTER
// ./static/lang/zh.js
// module id = z8sE
// module chunks = 1